import { useQuery, UseQueryResult } from 'react-query';
import { NotificationMessageTemplate } from 'types';
import { client } from 'utils/api-client';

function useNotificationMessageTemplate(
  notificationMessageTemplateId: string | undefined | null,
): UseQueryResult<{ data: NotificationMessageTemplate }> {
  return useQuery(
    ['notificationMessageTemplates', notificationMessageTemplateId],
    () => client.get(`notification-message-templates/${notificationMessageTemplateId}/`),
    {
      enabled: !!notificationMessageTemplateId,
    },
  );
}

export default useNotificationMessageTemplate;
